import { useState } from 'react';
import { TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { makeStyles } from '@mui/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            color: 'black'
        }
    },
    chip: {
        display: 'none'
    }
}));

export function FilterByDepartment({ cardholders, selectedDepartments, setSelectedDepartments, setPagination }) {
    const classes = useStyles();
    const [shrink, setShrink] = useState(false);

    // Remove empty values from cardholders.department
    const filteredArr = cardholders.filter(object => object.department && object.department.trim() !== '');
    // Remove Duplicates
    const distinctDepartments = [];
    filteredArr.forEach(cardholder => {
        if (!distinctDepartments.some(element => element.department === cardholder.department)) {
            distinctDepartments.push(cardholder);
        }
    });

    const handleSearchChange = async (event, newValue) => {
        setSelectedDepartments(newValue);
        setPagination({
            page: 0,
            rowsPerPage: 10
        });
    };

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option.department}`
    });

    const handleFocus = async () => {
        setShrink(true);
    };
    const handleBlur = async () => {
        setShrink(false);
    };

    return (
        <Autocomplete
            renderInput={params =>
                selectedDepartments.length === 0 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="All Departments  ‍ ‍‍ ‍ " />
                ) : selectedDepartments.length === 1 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="1 Department  ‍ ‍‍ ‍ " />
                ) : (
                    <TextField
                        {...params}
                        InputLabelProps={{ shrink: shrink }}
                        label={`${selectedDepartments.length} Departments  ‍ ‍‍ ‍ `}
                    />
                )
            }
            classes={classes}
            options={distinctDepartments}
            getOptionLabel={option => `${option.department}`}
            clearOnEscape={true}
            onFocus={handleFocus}
            onBlur={handleBlur}
            filterOptions={filterOptions}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option.id}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                    <li style={{ width: 380, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span style={{ color: '#122d55', fontSize: 15, fontWeight: 500 }}>{option.department}</span>
                    </li>
                </li>
            )}
            onChange={handleSearchChange}
            multiple
            disableCloseOnSelect
            size="small"
            ChipProps={{ className: classes.chip, disabled: 'true', size: 'small', deleteIcon: 'none' }}
            id="search-department-autocomplete"
            sx={{ width: '100%' }}
            className="transactions-search__item"
        />
    );
}
